





























































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import MechanicModule from '@/store/modules/Mechanic';

@Component({
  components: {
    Table,
  },
})
export default class PatternVersion extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Pattern',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Code',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Status',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Action',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  MechanicInstance = getModule(MechanicModule, this.$store);

  data = [];

  action = false;

  version = false;

  statusMaintenance = '0';

  url = '';

  prefix = '';

  created() {
    this.fetchPattern();
  }

  async fetchPattern() {
    await this.GeneralInstance.toggleLoading(true);
    const res = await this.MechanicInstance.FetchPatternList();
    if (res.code) {
      await this.checkError(res);
    } else {
      this.data = res;
    }
    await this.GeneralInstance.toggleLoading(false);
  }

  editAction(val) {
    this.prefix = val.code;
    this.action = true;
  }

  async handleMaintenance(val) {
    await this.GeneralInstance.toggleLoading(true);
    const res = await this.MechanicInstance.PatternMaintenance({
      isMaintenance: val !== '0',
      code: this.prefix,
    });
    if (res.code === 0) {
      await this.checkError(res);
    } else {
      await this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: res.message,
        alertColor: res.code === 0 ? 'success' : 'danger',
      });
    }
    this.action = false;
    await this.fetchPattern();
    await this.GeneralInstance.toggleLoading(false);
  }
}
